'use strict';

/**
 * "New in the Messaging Centre" MC banner.
 *
 * Clicking the banner opens the MC benefits promo PLP; closing it hides the banner
 * and records the promo as seen so it never shows again on this account.
 */
export class Mcbenefitsbanner {
	constructor(component_key) {
		this.id = component_key;
		this.component = yalwa.v.components[component_key];
		this.$root = jQuery(`.js-${this.id}`);
	}

	init() {
		if (!this.$root.length) {
			return;
		}
		this.$root.on('click', () => this.open_promo());
		this.$root.on('click', `.js-${this.id}_close`, (event) => {
			event.stopPropagation();
			this.close();
		});
	}

	open_promo() {
		const instance = (yalwa.v.component_instances || {})['dialog_mcbenefitsplp'];
		if (instance && typeof instance.show === 'function') {
			instance.show('promo_on_top');
		}
	}

	close() {
		yalwa.basics.hide(this.$root);
		this.dismiss();
	}

	dismiss() {
		if (this.dismissed || !this.component.csrf) {
			return;
		}
		this.dismissed = true;
		jQuery.post('/api/ajax/chat/', {
			action: 'mark_mc_benefits_banner_dismissed',
			csrf_bust: this.component.csrf,
		});
	}
}
